import React from 'react';
import Filter from './Filter';
import _ from 'lodash';
import Search from './Search';
import { makeStyles } from 'tss-react/mui';
import { useDispatch } from 'react-redux';
import { setFilterActive } from '../../actions.any';
import { useTranslation } from 'react-i18next';
const useStyles = makeStyles()(theme => {
    return {
        searchContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'start',
            rowGap: 8,
            marginBottom: 20,
            '@media (min-width: 720px)': {
                flexDirection: 'row',
                marginBottom: 0,
                alignItems: 'center',
                justifyContent: 'space-between',
            },
        }
    };
});
const SearchSpeakerStats = () => {
    const { classes } = useStyles();
    const { t } = useTranslation();
    const filter = ['statsActive', 'statsInactive'];
    const dispatch = useDispatch();
    const handleFilterStatus = (values) => {
        let _status = undefined;
        if (_.uniq(values).length === 1) {
            return dispatch(setFilterActive((_status !== 0 && _status !== 1) ? undefined : _status));
        }
        if (values.some((v) => v !== true)) {
            _status = values[0] ? 1 : 0;
        }
        return dispatch(setFilterActive((_status !== 0 && _status !== 1) ? undefined : _status));
    };
    return (React.createElement("div", { className: classes.searchContainer },
        React.createElement(Filter, { labelkey: 'filter.label.stats', status: filter, handleAction: handleFilterStatus }),
        React.createElement(Search, { placeholder: t('stats.enterDisplayname') })));
};
export default SearchSpeakerStats;
